 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLEPAGE from '@/components/Text/Titlepage'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTTOC from '@/components/Text/TOC'
 import TEXTAUTHORNOTE from '@/components/Text/AuthorNote'
 import TEXTDEDICATION from '@/components/Text/Dedication'
 import TEXTPARTONE from '@/components/Text/PartOne'
 import TEXTBOOKONE from '@/components/Text/BookOne'
 import TEXTPROLOGUE from '@/components/Text/Prologue'
 import TEXTCHAP_01 from '@/components/Text/Chap_01'
 import TEXTCHAP_02 from '@/components/Text/Chap_02'
 import TEXTCHAP_03 from '@/components/Text/Chap_03'
 import TEXTCHAP_04 from '@/components/Text/Chap_04'
 import TEXTCHAP_05 from '@/components/Text/Chap_05'
 import TEXTCHAP_06 from '@/components/Text/Chap_06'
 import TEXTCHAP_07 from '@/components/Text/Chap_07'
 import TEXTCHAP_08 from '@/components/Text/Chap_08'
 import TEXTCHAP_09 from '@/components/Text/Chap_09'
 import TEXTCHAP_10 from '@/components/Text/Chap_10'
 import TEXTPARTTWO from '@/components/Text/PartTwo'
 import TEXTCHAP_11 from '@/components/Text/Chap_11'
 import TEXTCHAP_12 from '@/components/Text/Chap_12'
 import TEXTCHAP_13 from '@/components/Text/Chap_13'
 import TEXTCHAP_14 from '@/components/Text/Chap_14'
 import TEXTCHAP_15 from '@/components/Text/Chap_15'
 import TEXTCHAP_16 from '@/components/Text/Chap_16'
 import TEXTCHAP_17 from '@/components/Text/Chap_17'
 import TEXTCHAP_18 from '@/components/Text/Chap_18'
 import TEXTCHAP_19 from '@/components/Text/Chap_19'
 import TEXTCHAP_20 from '@/components/Text/Chap_20'
 import TEXTPARTTHREE from '@/components/Text/PartThree'
 import TEXTCHAP_21 from '@/components/Text/Chap_21'
 import TEXTCHAP_22 from '@/components/Text/Chap_22'
 import TEXTCHAP_23 from '@/components/Text/Chap_23'
 import TEXTCHAP_24 from '@/components/Text/Chap_24'
 import TEXTCHAP_25 from '@/components/Text/Chap_25'
 import TEXTCHAP_26 from '@/components/Text/Chap_26'
 import TEXTCHAP_27 from '@/components/Text/Chap_27'
 import TEXTCHAP_28 from '@/components/Text/Chap_28'
 import TEXTCHAP_29 from '@/components/Text/Chap_29'
 import TEXTEPILOGUE from '@/components/Text/Epilogue'
 import LOVE_2 from '@/components/love_2'
 import TEXTNOTES from '@/components/Text/Notes'
 import TEXTAFTERWORD from '@/components/Text/Afterword'
 import TEXTACKNOWLEDGMENTS from '@/components/Text/Acknowledgments'
 import TEXTCTA from '@/components/Text/CTA'
 import TEXTDARKVISIONS_EXCERPT_AD from '@/components/Text/DARKVISIONS_excerpt_Ad'
 import TEXTHARDDOGTOKILL_AMAZON from '@/components/Text/HARDDOGTOKILL_AMAZON'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/TOC",
 			"name" : "Text/TOC",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/AuthorNote",
 			"name" : "Text/AuthorNote",
 			"component" : TEXTAUTHORNOTE
 		},
 		{
 			"path" : "/Text/Dedication",
 			"name" : "Text/Dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/PartOne",
 			"name" : "Text/PartOne",
 			"component" : TEXTPARTONE
 		},
 		{
 			"path" : "/Text/BookOne",
 			"name" : "Text/BookOne",
 			"component" : TEXTBOOKONE
 		},
 		{
 			"path" : "/Text/Prologue",
 			"name" : "Text/Prologue",
 			"component" : TEXTPROLOGUE
 		},
 		{
 			"path" : "/Text/Chap_01",
 			"name" : "Text/Chap_01",
 			"component" : TEXTCHAP_01
 		},
 		{
 			"path" : "/Text/Chap_02",
 			"name" : "Text/Chap_02",
 			"component" : TEXTCHAP_02
 		},
 		{
 			"path" : "/Text/Chap_03",
 			"name" : "Text/Chap_03",
 			"component" : TEXTCHAP_03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js